import DataService from './data-service';

export  default DataService;